import { tap } from 'rxjs';
import { ChangeDetectorRef, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { PromoBannerComponent } from '@shared/components/promo-banners/components/promo-banner/promo-banner.component';
import { PromoBannersService } from '@shared/components/promo-banners/services/promo-banners.service';
import { PromoBannerDTO } from '@shared/types/dtos/promo-banner-dto.type';

@Component({
    selector: 'app-promo-banners-container',
    templateUrl: './promo-banners-container.component.html',
    styleUrls: ['./promo-banners-container.component.scss'],
    imports: [CommonModule, PromoBannerComponent]
})
export class PromoBannersContainerComponent implements OnInit {
  banners: PromoBannerDTO[] = [];

  constructor(
    private readonly destroyRef: DestroyRef,
    private readonly cdr: ChangeDetectorRef,
    private readonly promoBannerService: PromoBannersService
  ) {}

  ngOnInit() {
    this.initFetchPromoBanners().subscribe();
  }

  onClickBannerAction(id: number) {
    this.promoBannerService.incrementCTAClicksCounter(id);
  }

  onClose(id: number) {
    this.promoBannerService.dismiss(id);
  }

  onDoNotShowAgain(id: number) {
    this.promoBannerService.dismiss(id);
    this.promoBannerService.doNotShowAgain(id);
  }

  protected trackById(index: number, banner: PromoBannerDTO): number {
    return banner.id;
  }

  private initFetchPromoBanners() {
    return this.promoBannerService.getBanners$().pipe(
      takeUntilDestroyed(this.destroyRef),
      tap((banners) => {
        this.banners = banners;
        this.cdr.markForCheck();
      })
    );
  }
}
